import { useGet } from './useHttpHooks';
import { TopQuestionsCategories } from '../types';

const useGetTopQuestionsCategories = () =>
    useGet<TopQuestionsCategories>(
        '/api/analytics/top-questions-and-categories',
        {
            errorMessage:
                'GET /api/analytics/top-questions-and-categories failed'
        }
    );

export default useGetTopQuestionsCategories;
